import { BottomSheetWrapper } from '@psl/appComponents/BottomSheetWrapper';
import { ModalWrapper } from '@psl/appComponents/ModalWrapper';
import { useIsMobileLayout } from '@psl/components/styles/responsive';
import { NavigatorScreenParams } from '@react-navigation/native';
import { lazy } from 'react';
import { wrapLazyNavigatorScreen } from '../../functions/navigation/utils/wrapNavigatorScreen';
import type { OnboardingFlowScreenParams } from './components/OnboardingFlowPageContent';

const OnboardingFlowPageContent = lazy(
  () => import('./components/OnboardingFlowPageContent'),
);

const OnboardingFlowPage = wrapLazyNavigatorScreen(
  (_: NavigatorScreenParams<OnboardingFlowScreenParams> | {}) => {
    const isMobile = useIsMobileLayout();
    if (!isMobile) {
      return (
        <ModalWrapper>
          <OnboardingFlowPageContent />
        </ModalWrapper>
      );
    }
    return (
      <BottomSheetWrapper>
        <OnboardingFlowPageContent />
      </BottomSheetWrapper>
    );
  },
  {
    cardOverlayEnabled: true,
    animationEnabled: false,
    detachPreviousScreen: false,
    cardStyle: {
      backgroundColor: 'transparent',
    },
    headerShown: false,
  },
);

export default OnboardingFlowPage;
